import { Navigate, useLocation } from "react-router-dom";

export function LegacyInboxRedirect({ segment }: { readonly segment: "action" | "boards" }) {
  const location = useLocation();
  return (
    <Navigate
      replace
      to={`/inbox/${segment}${location.search}${location.hash}`}
    />
  );
}
